import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ApiCallsService {
  loader: boolean = false;
  getUser: any;
  userInfo: any;
  addUserDetailResponse: any;
  addUserResponse: any;
  getAddr: any;
  getUserDetailObject: any;
  cartObject: any = [];
  OrderIdArray: any = [];
  ordersObject: any = [];
  ordersRestaurants: any = [];
  addressIndex: any;
  truePinCode: any;
  trueLocation: any;
  topPicksMenu: any;
  getAllRes: any;
  deliveryBoyData: any;
  getAllResClosedAlso: any;
  getAllMenu: any;
  getMenu: any;
  getCategories: any;
  addr: any;
  grandTotal: any;
  userName: any;
  getOrders: any;
  trueRestaurant: any;
  adminControls: any;
  resStatus: any;
  orderDetails: any;
  charge: any;
  activeDeliveryBoy: any;
  ads: any;
  deleteAddrResponse: any;
  pinCodeCheck: boolean;
  admins: any;
  minOrderAmount: any;
  addTokenResponse: any;
  updateTokenResponse: any;
  complaintResponse: any;
  subCatDetails: any;
  sendNotificationResponse: any;
  setRatingResponse: any;

  constructor(private http: HttpClient, public router: Router) {
    this.userInfo = "";
    this.userInfo = JSON.parse(localStorage.getItem("trueUser"));
    this.addressIndex = 0;
    this.trueRestaurant = "";
    this.pinCodeCheck = false;
  }

  async updateLocPin() {
    this.truePinCode = await this.getAddr[this.addressIndex].pinCode;
    this.trueLocation = await this.getAddr[this.addressIndex].addressLine1;
    await this.initializeHome().then(async () => {
      this.getActiveUser();
    });
  }

  async initializeHome() {
    await this.topPicks(this.truePinCode);
    await this.getAllRestaurants(this.truePinCode);
    await this.getAllMenuItems(this.truePinCode);
    await this.getAllCategory(this.truePinCode);
    await this.getAllRestaurantsClosedAlso(this.truePinCode);
    await this.getUserDetails(JSON.parse(localStorage.getItem("trueUser")).uid);
    await this.getAllOrders();
    await this.getAdminControls(this.truePinCode);
    await this.getDeliveryBoyDetails(this.truePinCode);
    await this.getAds(this.truePinCode);
    await this.getUserAdd(JSON.parse(localStorage.getItem("trueUser")).uid);
    await this.getAllAdmins().then(()=>{
      for (let x = 0; x < this.admins.length; x++) {
        this.pinCodeCheck = false;
        console.log(this.admins[x].pinCode,this.truePinCode,this.admins[x].pinCode === this.truePinCode,"checcckkkk")
        if (this.admins[x].pinCode === this.truePinCode) {
          this.pinCodeCheck = true;
          this.router.navigateByUrl("/tabs");
          break;
        }
      }
    });
    if (!this.pinCodeCheck) {
      this.router.navigateByUrl("/no-service");
    }
  }

  async checkAddr() {
    console.log("first")
    if (JSON.parse(localStorage.getItem("trueUser"))) {
      console.log("second")
      await this.getUserAdd(JSON.parse(localStorage.getItem("trueUser")).uid);
      await this.getUserDetails(
        JSON.parse(localStorage.getItem("trueUser")).uid
      );
      console.log("three")
      if (this.getAddr.length == 0) {
        this.router.navigateByUrl("/user-info");
      } else {
        console.log("four")
        this.truePinCode = this.getAddr[this.addressIndex].pinCode;
        this.trueLocation = this.getAddr[this.addressIndex].addressLine1;
        console.log("five")
        await this.initializeHome().then(() => {
          this.getActiveUser();
          console.log("six")
        });
      }
    }
  }

  getActiveUser() {
    for (let x = 0; x < this.deliveryBoyData.length; x++) {
      if (this.deliveryBoyData[x].activeStatus === true) {
        this.activeDeliveryBoy = this.deliveryBoyData[x];
        break;
      }
    }
  }

  orderGrandTotal() {
    this.grandTotal = 0;
    for (let i = 0; i < this.cartObject.length; i++) {
      this.grandTotal =
        this.grandTotal + this.cartObject[i].price * this.cartObject[i].count;
    }
  }

  async topPicks(pinCode) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/restaurant/getTopPicks/" +
        pinCode;
      this.loader = true;
      this.topPicksMenu = await this.http.get(url).toPromise();
      return this.topPicksMenu;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getAllRestaurants(pinCode) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/restaurant/getAllRestaurants/" +
        pinCode;
      this.loader = true;
      this.getAllRes = await this.http.get(url).toPromise();
      return this.getAllRes;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getAdminControls(pinCode) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/admin/getAdminControls/" +
        pinCode;
      this.loader = true;
      this.adminControls = await this.http.get(url).toPromise();
      return this.adminControls;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getAllAdmins() {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/admin/getTotalAdmins"
      this.loader = true;
      this.admins = await this.http.get(url).toPromise();
      console.log(this.admins,"admins")
      return this.admins;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getAds(pinCode) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/admin/getAds/" + pinCode;
      this.loader = true;
      this.ads = await this.http.get(url).toPromise();
      console.log(this.ads);
      return this.ads;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getDeliveryBoyDetails(pinCode) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/admin/getDeliveryBoyDetails/" +
        pinCode;
      this.loader = true;
      this.deliveryBoyData = await this.http.get(url).toPromise();
      console.log(this.deliveryBoyData);
      return this.deliveryBoyData;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getResStatus(res) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/restaurant/getCurrentResStatus/" +
        res;
      this.loader = true;
      this.resStatus = await this.http.get(url).toPromise();
      return this.resStatus;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getParticularOrder(Id) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/restaurant/getOrderWithId/" +
        Id;
      this.loader = true;
      this.orderDetails = await this.http.get(url).toPromise();
      return this.orderDetails;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getAllRestaurantsClosedAlso(pinCode) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/restaurant/getAllRestaurantsByPincode/" +
        pinCode;
      this.loader = true;
      this.getAllResClosedAlso = await this.http.get(url).toPromise();
      return this.getAllResClosedAlso;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getAllMenuItems(pinCode) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/restaurant/getMenuByPincode/" +
        pinCode;
      this.loader = true;
      this.getAllMenu = await this.http.get(url).toPromise();
      return this.getAllMenu;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getMenuByRes(pinCode, restaurant) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/restaurant/getMenuByRestaurant/" +
        pinCode +
        "/" +
        restaurant;
      this.loader = true;
      this.getMenu = await this.http.get(url).toPromise();
      return this.getMenu;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getAllCategory(pinCode) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/restaurant/getCategories/" +
        pinCode;
      this.loader = true;
      this.getCategories = await this.http.get(url).toPromise();
      return this.getCategories;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async addNewAddr(dataToSend) {
    try {
      this.loader = true;
      var url = "https://local-eats-india.herokuapp.com/user/addnewAddr  ";
      this.addUserDetailResponse = await this.http
        .post(url, dataToSend, {
          headers: new HttpHeaders({ "content-type": "application/json" }),
        })
        .toPromise();
      return this.addUserDetailResponse;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async deleteAddr(dataToSend) {
    try {
      this.loader = true;
      var url = "https://local-eats-india.herokuapp.com/user/deleteAddr  ";
      this.deleteAddrResponse = await this.http
        .post(url, dataToSend, {
          headers: new HttpHeaders({ "content-type": "application/json" }),
        })
        .toPromise();
      return this.deleteAddrResponse;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  // async getUserDetails(uid) {
  //   try {
  //     var url =
  //       "https://local-eats-india.herokuapp.com/user/geUserDetais/" + uid;
  //     this.loader = true;
  //     this.getUser = await this.http.get(url).toPromise();
  //     this.userName=this.getUser[0].name;
  //     return this.getUser;
  //   } catch (e) {
  //     return JSON.stringify(e);
  //   } finally {
  //     this.loader = false;
  //   }
  // }

  async getUserDetails(uid) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/user/geUserDetais/" + uid;
      this.loader = true;
      this.getUserDetailObject = await this.http.get(url).toPromise();
      console.log(this.getUserDetailObject, "userDEtailObject");
      this.userName = this.getUserDetailObject[0].name;
      return this.getUserDetailObject;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async addUserDetails(dataToSend) {
    try {
      this.loader = true;
      var url = "https://local-eats-india.herokuapp.com/user/addUserDetails  ";
      this.addUserDetailResponse = await this.http
        .post(url, dataToSend, {
          headers: new HttpHeaders({ "content-type": "application/json" }),
        })
        .toPromise();
      return this.addUserDetailResponse;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async addUser(dataToSend) {
    try {
      this.loader = true;
      var url = "https://local-eats-india.herokuapp.com/user/addUser";
      this.addUserResponse = await this.http
        .post(url, dataToSend, {
          headers: new HttpHeaders({ "content-type": "application/json" }),
        })
        .toPromise();
      return this.addUserResponse;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getUserAdd(uid) {
    try {
      var url = "https://local-eats-india.herokuapp.com/user/geUserAddr/" + uid;
      this.loader = true;
      this.getAddr = await this.http.get(url).toPromise();
      console.log(this.getAddr, "gjgjgj");
      return this.getAddr;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async getAllOrders() {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/restaurant/getAllOrders/" +
        JSON.parse(localStorage.getItem("trueUser")).uid;
      this.loader = true;
      this.getOrders = await this.http.get(url).toPromise();
      return this.getOrders;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  deliveryChargeUpdate() {
    for (let x = 0; x < this.cartObject.length; x++) {
      for (let y = 0; y < this.getAllResClosedAlso.length; y++) {
        if (
          this.cartObject[x].restaurant ===
          this.getAllResClosedAlso[y].restaurantName
        ) {
          console.log(this.getAddr[this.addressIndex].area)
          if(this.getAddr[this.addressIndex].area==="wcl"){
            this.charge=this.adminControls[0].wclDeliveryCharge;
          }else{
            this.charge = this.getAllResClosedAlso[y].deliveryCharge;
          }
          this.minOrderAmount=this.getAllResClosedAlso[y].minOrderAmount
          console.log(this.getAllResClosedAlso[y].minOrderAmount,this.getAllResClosedAlso[y].restaurantName)
          break;
        }
      }
      this.cartObject[x].minOrderAmount = this.minOrderAmount;
      if (this.adminControls[0].isdeliveryCharge) {
        this.cartObject[x].deliveryCharge = this.charge;
      } else {
        this.cartObject[x].deliveryCharge = 0;
      }
    }
    console.log(this.cartObject);
  }


  async addDeviceToken(dataToSend) {
    try {
      //this.loader = true;
      var url = "https://local-eats-india.herokuapp.com/admin/addDeviceTokens";
      this.addTokenResponse = await this.http
        .post(url, dataToSend, {
          headers: new HttpHeaders({ "content-type": "application/json" }),
        })
        .toPromise();
      return this.addTokenResponse;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      //this.loader = false;
    }
  }

  async addDeviceToToken(dataToSend) {
    try {
      this.loader = true;
      var url = "https://local-eats-india.herokuapp.com/admin/addUserDeviceToToken";
      this.updateTokenResponse = await this.http
        .post(url, dataToSend, {
          headers: new HttpHeaders({ "content-type": "application/json" }),
        })
        .toPromise();
      return this.updateTokenResponse;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async setRating(dataToSend) {
    try {
      this.loader = true;
      var url = "https://local-eats-india.herokuapp.com/restaurant/setRating";
      this.setRatingResponse = await this.http
        .post(url, dataToSend, {
          headers: new HttpHeaders({ "content-type": "application/json" }),
        })
        .toPromise();
      return this.setRatingResponse;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async sendOrderNotification(dataToSend){
    try {
      var url = "https://local-eats-india.herokuapp.com/admin/sendOrderNotificationToRestaurant";
      this.updateTokenResponse = await this.http
        .post(url, dataToSend, {
          headers: new HttpHeaders({ "content-type": "application/json" }),
        })
        .toPromise();
      return this.updateTokenResponse;
    } catch (e) {
      return JSON.stringify(e);
    } 
  }

  
  async submitComplaint(dataToSend){
    try {
      var url = "https://local-eats-india.herokuapp.com/admin/submitComplaint";
      this.complaintResponse = await this.http
        .post(url, dataToSend, {
          headers: new HttpHeaders({ "content-type": "application/json" }),
        })
        .toPromise();
      return this.complaintResponse;
    } catch (e) {
      return JSON.stringify(e);
    } 
  }

  async getSubCategoryByRes(pincode,res) {
    try {
      var url =
        "https://local-eats-india.herokuapp.com/restaurant/getSubCategories/" +
        pincode+"/"+res;
      this.loader = true;
      this.subCatDetails = await this.http.get(url).toPromise();
      return this.subCatDetails;
      
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

  async sendNotificationToDeliveryBoy(dataToSend) {
    try {
      this.loader = true;
      var url = "https://local-eats-india.herokuapp.com/admin/sendNewOrderNotificationToDelBoy";
      this.sendNotificationResponse = await this.http
        .post(url, dataToSend, {
          headers: new HttpHeaders({ "content-type": "application/json" }),
        })
        .toPromise();
      return this.sendNotificationResponse;
    } catch (e) {
      return JSON.stringify(e);
    } finally {
      this.loader = false;
    }
  }

}
